<div *ngIf="article" class="min-h-screen pt-32 pb-24 bg-gradient-to-br from-yellow-50 via-white to-orange-50 dark:from-gray-900 dark:via-black dark:to-gray-950 animate-fade-in-up">
  <article class="container mx-auto px-4 max-w-4xl">
    
    <!-- Breadcrumb -->
    <nav class="mb-8 text-sm text-gray-500">
      <a routerLink="/ressources" class="text-mesh-800 hover:underline">Articles</a>
      <span class="mx-2">/</span>
      <span>{{ article.type }}</span>
    </nav>

    <!-- Header Section -->
    <header class="mb-16">
      <div class="mb-6">
        <span class="inline-block bg-yellow-100 text-mesh-800 px-4 py-2 rounded-full text-xs font-bold uppercase tracking-wider border border-yellow-200">
          {{ article.type || 'Article' }}
        </span>
      </div>
      <h1 class="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 dark:text-white leading-tight mb-8 animate-fade-in-down">
        <span *ngIf="article.titleAccent" class="text-yellow-500 dark:text-yellow-400">{{ article.titleAccent }}</span>{{ article.titleAccent ? ' ' : '' }}{{ article.title }}
      </h1>
      
      <div class="flex items-center justify-between pt-8 border-t border-gray-200 flex-wrap gap-8">
        <div class="flex items-center gap-4">
          <img src="/assets/team/olivier-girodin.jpg" [alt]="article.author" class="w-12 h-12 rounded-full border-2 border-gray-300" />
          <div class="flex flex-col">
            <span class="font-bold text-gray-800 text-base">{{ article.author }}</span>
            <span class="text-sm text-gray-600">Lead Architect @ Mesh Box</span>
          </div>
        </div>
        <div class="flex gap-6 text-gray-500 text-sm">
          <span class="flex items-center gap-1"><i class="far fa-calendar"></i> {{ formatDate(article.date) }}</span>
          <span class="flex items-center gap-1"><i class="far fa-clock"></i> {{ article.readTime }}</span>
        </div>
      </div>
    </header>

    <!-- HTML Content (Loaded from file) -->
    <div class="prose max-w-none animate-fade-in" [innerHTML]="safeContent">
    </div>

    <!-- Final Support Section (Generic) -->
    <footer class="mt-20 p-16 bg-gray-50 dark:bg-gray-800 rounded-3xl border border-gray-200 dark:border-gray-700 text-center animate-fade-in-up">
      <h3 class="text-3xl font-bold mb-4 text-gray-900 dark:text-white">Besoin d'une expertise ?</h3>
      <p class="mb-10 text-lg text-gray-600 dark:text-gray-300 max-w-xl mx-auto">
        Nos architectes vous accompagnent dans la modernisation de vos infrastructures Angular et Node.js.
      </p>
      <div class="flex flex-col sm:flex-row gap-4 justify-center">
        <a 
          href="https://cal.mesh-box.fr/ogirodin/30min"
          target="_blank"
          rel="noopener"
          class="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-full shadow-sm text-white bg-mesh-800 hover:bg-mesh-900 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-mesh-500" 
        >
          Réserver un diagnostic (30 min)
        </a>
        <a routerLink="/contact" class="inline-flex items-center justify-center px-8 py-4 border border-gray-300 text-base font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-mesh-500">
          Nous contacter
        </a>
      </div>
    </footer>

  </article>
</div>